import * as TYPES from './mutationTypes'

export default {
  setRustPageTab({ commit }, params) {
    commit(TYPES.RUST_PAGE_TAB, {
      params
    })
  },

  setSolidityPageTab({ commit }, params) {
    commit(TYPES.SOLIDITY_PAGE_TAB, {
      params
    })
  }
}
